import { useMutation, useQueryClient } from 'react-query';
import { spendInviteCode, type EnterInviteCodeResponse } from '../../services/userService';

export function useSpendInviteCode() {
  const queryClient = useQueryClient();
  return useMutation<EnterInviteCodeResponse, Error, string>(
    (inviteCode) => spendInviteCode(inviteCode),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['users']);
        queryClient.invalidateQueries(['bettieBalances']);
        queryClient.invalidateQueries(['userInvitationRecap']);
      }
    }
  );
}
